import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createCity",
    serviceName: "admin",
    query: gql`
      mutation createCity(
        $title: String!
        $state_id: String
        $details: String
      ) {
        createCity(title: $title, state_id: $state_id, details: $details) {
          messages
        }
      }
    `,
  },
};

export default schema;
